/*
 * @Author: edvardchen
 * @Date:   2016-11-11 21:36:29
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:30:54
 */
import _ from 'lodash';
import qs from 'query-string';
import fetchJSONP from 'fetch-jsonp';
import { parseJSON, checkStatus } from './helper';

/* eslint-disable import/prefer-default-export */
export function getVideoAtShareBottom() {
  const params = qs.stringify({
    groupid: 520,
    pagenum: 0,
    pagesize: 12,
    edition: 0,
    siftcon: '0_0_0',
    sort: 1,
    _t: Date.now(),
    ch: '001500',
  });
  return global
    .fetch(`//v.html5.qq.com/api/getvideolist?${params}`)
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      const data = res.vVideoBasic[_.random(0, res.vVideoBasic.length - 1)];
      if (!data || !data.vSetNum[0]) {
        return;
      }
      const { iSrc, sRealSetNum } = data.vSetNum[0] || {};
      const urlParams = {
        vid: data.lVideoId,
        type: data.iType,
        src: iSrc,
        num: sRealSetNum,
        ch: '002307',
      };
      return {
        image: data.sPicUrl,
        title: data.sVideoName,
        id: data.lVideoId,
        url: `http://v.html5.qq.com/#p=sPlayer&${qs.stringify(urlParams)}`,
      };
    });
}

/**
 * 获取手腾视频的播放地址
 * @param  {String} options.vid
 * @param  {Boolean} options.isAndroid
 * @return {Promise}
 */
export function fetchQQVideoPlayUrl({ vid, isAndroid }) {
  const sdtfrom = isAndroid ? 'v5143' : 'v3142';
  const params = qs.stringify({
    charge: 0,
    sphls: 0,
    sb: 1,
    nocache: 0,
    defaultfmt: 'auto',
    otype: 'json',
    platform: 11001, // Android: 160301, iPhone: 160401
    sdtfrom,
    vid,
  });
  return fetchJSONP(`//h5vv.video.qq.com/getinfo?${params}`)
    .then((res) => res.json())
    .then((data) => {
      // Android HTML5: 10, ipad html5: 0
      const platform = isAndroid ? '10' : '0';
      if (!data || data.s !== 'o' || (data.vl.vi && data.vl.vi[0].st !== 2)) {
        // Need pay if: data.vl.vi[0].st === 8
        console.log('video cannot play', data);
        throw new Error('video cannot play');
      }
      let videoUrl;
      let tmp;
      try {
        tmp = data.vl.vi[0] || '';
        const urlData = qs.stringify({
          vkey: tmp.fvkey,
          br: tmp.br,
          fmt: 'auto',
          level: tmp.level,
          platform,
          sdtfrom,
        });
        videoUrl = `${tmp.ul.ui[0].url}${tmp.fn}?'${urlData}`;
      } catch (e) {
        console.error('video data error', e);
        throw e;
      }
      return {
        title: tmp && tmp.ti,
        url: videoUrl,
      };
    });
}

/**
 * 视频嗅探
 * @param  {String} vid
 * @return {Promise}
 */
export function sniff(vid) {
  return global.fetch(`//sniff.html5.qq.com/capture?vid=${vid}`).then(checkStatus).then(parseJSON);
}
